import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { GetAllUserDevicesAction } from '../../Redux/Actions/Devices_Action';
import { Getalldatauserlog_forsearch } from '../../Redux/Actions/AuthAction';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Ic = {
  Desktop: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
    </svg>
  ),
  Mobile: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="17" r="1"/>
    </svg>
  ),
  Tablet: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>
    </svg>
  ),
  Monitor: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
    </svg>
  ),
  Phone: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="17" r="1"/>
    </svg>
  ),
  Pin: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
    </svg>
  ),
  Clock: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  ChevronLeft: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="15 18 9 12 15 6"/></svg>
  ),
  ChevronRight: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="9 18 15 12 9 6"/></svg>
  ),
  Refresh: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>
    </svg>
  ),
  Filter: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
    </svg>
  ),
  X: () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  Excel: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="8" y1="13" x2="16" y2="13"/>
      <line x1="8" y1="17" x2="16" y2="17"/>
      <polyline points="10 9 9 9 8 9"/>
    </svg>
  ),
  ChevronDown: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
  ),
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
const getDeviceInfo = (type, deviceName) => {
  if (type === 'mobile')  return { label: deviceName || 'Mobile Device',  sub: 'MOBILE ACCESS',    Icon: Ic.Mobile,  color: '#3b82f6', bg: '#eff6ff' };
  if (type === 'tablet')  return { label: deviceName || 'Tablet Device',  sub: 'SHOWROOM DEVICE',  Icon: Ic.Tablet,  color: '#8b5cf6', bg: '#f5f3ff' };
  return                         { label: deviceName || 'Desktop Device', sub: 'SYSTEM MANAGED',   Icon: Ic.Desktop, color: '#0f172a', bg: '#f1f5f9' };
};

const getBrowser = (ua = '') => {
  if (ua.includes('Edg'))    return { name: 'Edge',    version: '119', logo: '🌐' };
  if (ua.includes('Chrome')) return { name: 'Chrome',  version: '122', logo: '🟡' };
  if (ua.includes('Firefox'))return { name: 'Firefox', version: '121', logo: '🦊' };
  if (ua.includes('Safari')) return { name: 'Safari',  version: '17.4',logo: '🧭' };
  return                             { name: 'Browser', version: '',    logo: '🌐' };
};

const getTimeAgo = (date) => {
  const diff = Date.now() - new Date(date);
  const m = Math.floor(diff / 60000);
  const h = Math.floor(diff / 3600000);
  const d = Math.floor(diff / 86400000);
  if (m < 1)  return 'Just now';
  if (m < 60) return `${m} minutes ago`;
  if (h < 24) return `${h} hours ago`;
  return `${d} days ago`;
};

const getInitials = (name = '') =>
  name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?';

const AVATAR_COLORS = ['#6366f1','#8b5cf6','#ec4899','#f59e0b','#10b981','#0ea5e9','#f43f5e','#14b8a6'];
const avatarColor = (s = '') => AVATAR_COLORS[s.charCodeAt(0) % AVATAR_COLORS.length];

// ─── Avatar ───────────────────────────────────────────────────────────────────
const Avatar = ({ src, name, size = 34 }) => {
  const [ok, setOk] = React.useState(!!src);
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', flexShrink: 0,
      background: avatarColor(name), overflow: 'hidden',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.36, fontWeight: 700, color: '#fff',
      border: '2px solid #fff', boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
    }}>
      {ok && src
        ? <img src={src} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={() => setOk(false)} />
        : getInitials(name)}
    </div>
  );
};

// ─── Tab Button ───────────────────────────────────────────────────────────────
const TabBtn = ({ active, onClick, children }) => (
  <button onClick={onClick} style={{
    padding: '8px 18px', borderRadius: 8, border: 'none', cursor: 'pointer',
    fontSize: 13, fontWeight: active ? 600 : 500,
    background: active ? '#0f172a' : 'transparent',
    color: active ? '#fff' : '#64748b',
    transition: 'all .15s', fontFamily: 'inherit',
  }}>{children}</button>
);

// ─── Status Badge ─────────────────────────────────────────────────────────────
const StatusBadge = ({ status }) => {
  const map = {
    active:   { label: 'ACTIVE',   color: '#059669', bg: '#d1fae5', dot: '#10b981' },
    inactive: { label: 'INACTIVE', color: '#64748b', bg: '#f1f5f9', dot: '#94a3b8' },
  };
  const s = map[status] || map.inactive;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      padding: '4px 10px', borderRadius: 20,
      fontSize: 11, fontWeight: 700, letterSpacing: '0.05em',
      color: s.color, background: s.bg,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: s.dot, display: 'inline-block' }}/>
      {s.label}
    </span>
  );
};

const inputStyle = {
  padding: '7px 10px', border: '1px solid #e2e8f0', borderRadius: 8,
  fontSize: 13, fontFamily: 'inherit', color: '#0f172a',
  background: '#fff', outline: 'none', height: 34,
};

// ─── Main Component ───────────────────────────────────────────────────────────
export const UserDevices = () => {
  const dispatch     = useDispatch();
  const theme        = useTheme();
  const isDark       = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  const [refreshing,    setRefreshing]    = useState(false);
  const [activeTab,     setActiveTab]     = useState('all');
  const [page,          setPage]          = useState(1);
  const [filterOpen,    setFilterOpen]    = useState(false);
  const itemsPerPage = 10;

  // ── Filter State ──────────────────────────────────────────────────────────
  const [filters, setFilters] = useState({ user: '', deviceType: '', from: '', to: '' });
  const [appliedFilters, setAppliedFilters] = useState({ user: '', deviceType: '', from: '', to: '' });

  const setFilter = (key, val) => setFilters(f => ({ ...f, [key]: val }));

  const applyFilters = () => {
    setAppliedFilters({ ...filters });
    setPage(1);
    setFilterOpen(false);
  };

  const resetFilters = () => {
    const empty = { user: '', deviceType: '', from: '', to: '' };
    setFilters(empty);
    setAppliedFilters(empty);
    setPage(1);
  };

  const removeTag = (key) => {
    const updated = { ...appliedFilters, [key]: '' };
    setFilters(updated);
    setAppliedFilters(updated);
    setPage(1);
  };

  const activeTagKeys = Object.entries(appliedFilters)
    .filter(([, v]) => v !== '')
    .map(([k]) => k);

  const tagLabels = {
    user:       v => `User: ${v}`,
    deviceType: v => `Type: ${v}`,
    from:       v => `From: ${v}`,
    to:         v => `To: ${v}`,
  };

  // ── Redux ──────────────────────────────────────────────────────────────────
  const res     = useSelector(s => s.All_Users_Devices.User_Devices);
  const loading = useSelector(s => s.All_Users_Devices.loading);
  const resAuth = useSelector(s => s.AuthRoot.Signup);

  const devices   = res?.data || [];
  const EXCLUDE   = ['Default','Default M','Default T','Default S','Deveolper','Dev'];
  const usersAuth = (Array.isArray(resAuth?.data) ? resAuth.data : [])
    .filter(u => !EXCLUDE.includes(u.name));

  const refresh = async () => {
    setRefreshing(true);
    await dispatch(GetAllUserDevicesAction()).catch(() => {});
    setRefreshing(false);
  };

  useEffect(() => {
    if (!devices.length) refresh();
    dispatch(Getalldatauserlog_forsearch()).catch(() => {});
  }, []);

  // ── Stats ──────────────────────────────────────────────────────────────────
  const stats = {
    total:   devices.length,
    active:  devices.filter(d => d.isActive).length,
    desktop: devices.filter(d => d.deviceType === 'desktop').length,
    mobile:  devices.filter(d => d.deviceType === 'mobile').length,
  };

  // ── Filtering ──────────────────────────────────────────────────────────────
  const filtered = devices
    .filter(d => {
      if (activeTab === 'active')   return d.isActive;
      if (activeTab === 'inactive') return !d.isActive;
      return true;
    })
    .filter(d => {
      const userName  = d.userId?.name?.toLowerCase() || '';
      const matchUser = !appliedFilters.user       || userName.includes(appliedFilters.user.toLowerCase());
      const matchType = !appliedFilters.deviceType || d.deviceType === appliedFilters.deviceType;
      const activity  = new Date(d.lastActivity);
      const matchFrom = !appliedFilters.from       || activity >= new Date(appliedFilters.from);
      const matchTo   = !appliedFilters.to         || activity <= new Date(appliedFilters.to + 'T23:59:59');
      return matchUser && matchType && matchFrom && matchTo;
    });

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const pageItems  = filtered.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const desktopPct = stats.total ? Math.round(stats.desktop / stats.total * 100) : 0;
  const mobilePct  = stats.total ? Math.round(stats.mobile  / stats.total * 100) : 0;

  // ── Export to Excel (CSV) ──────────────────────────────────────────────────
  const exportToExcel = () => {
    const rows = [
      ['Device Type', 'Device Name', 'User Name', 'User Role', 'IP Address', 'City', 'Country', 'Browser', 'Status', 'Last Activity'],
      ...filtered.map(d => {
        const di = getDeviceInfo(d.deviceType, d.deviceName);
        const br = getBrowser(d.userAgent);
        return [
          d.deviceType || '',
          di.label,
          d.userId?.name || 'Unknown',
          d.userId?.role || '',
          d.ipAddress || '',
          d?.location?.city || '',
          d?.location?.country || '',
          `${br.name} ${br.version}`.trim(),
          d.isActive ? 'Active' : 'Inactive',
          new Date(d.lastActivity).toLocaleString(),
        ];
      }),
    ];
    const csv  = rows.map(r => r.map(c => `"${String(c).replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url;
    a.download = `devices_export_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ─── CSS ──────────────────────────────────────────────────────────────────
  const css = `
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
    .udm-wrap * { box-sizing: border-box; }
    .udm-scroll::-webkit-scrollbar { width: 5px; height: 5px; }
    .udm-scroll::-webkit-scrollbar-track { background: transparent; }
    .udm-scroll::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 4px; }
    .udm-row { transition: background .12s; }
    .udm-row:hover { background: #f8fafc !important; }
    .udm-fi:focus { border-color: #0D47A1 !important; box-shadow: 0 0 0 3px rgba(13,71,161,.1); }
    @keyframes udm-spin { to { transform: rotate(360deg); } }
    .udm-spin { animation: udm-spin .9s linear infinite; }
    .udm-filter-dropdown {
      position: absolute;
      top: calc(100% + 8px);
      right: 0;
      z-index: 100;
      background: #fff;
      border: 1px solid #e2e8f0;
      border-radius: 14px;
      padding: 16px;
      box-shadow: 0 8px 30px rgba(0,0,0,0.10);
      min-width: 420px;
      animation: udm-fade-in 0.15s ease;
    }
    @keyframes udm-fade-in { from { opacity:0; transform: translateY(-6px); } to { opacity:1; transform: translateY(0); } }
    .udm-export-btn:hover { background: #1565c0 !important; }
    .udm-filter-btn-active { background: #eff6ff !important; border-color: #3b82f6 !important; color: #1d4ed8 !important; }
  `;

  return (
    <div className="udm-wrap" style={{
      position: 'fixed',
      top: '50px',
      left: sidebarWidth,
      right: 0,
      bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      backgroundColor: '#f0f4f8',
      fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    }}>
      <style>{css}</style>

      {/* ── Scrollable Body ── */}
      <div className="udm-scroll" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}>

        {/* ── Header ── */}
        <div style={{ padding: '28px 32px 0', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 6 }}>
            <div>
              <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#0f172a', letterSpacing: '-0.4px' }}>
                Connected Devices Management
              </h1>
              <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>
                Real-time oversight of all ecosystem entry points and security status.
              </p>
            </div>
            <button
              onClick={refresh}
              disabled={refreshing}
              style={{
                display: 'flex', alignItems: 'center', gap: 7,
                padding: '9px 16px', background: '#fff', border: '1px solid #e2e8f0',
                borderRadius: 10, fontSize: 13, fontWeight: 500, cursor: refreshing ? 'not-allowed' : 'pointer',
                color: '#374151', opacity: refreshing ? 0.6 : 1, fontFamily: 'inherit',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              }}
            >
              <span className={refreshing ? 'udm-spin' : ''}><Ic.Refresh /></span>
              {refreshing ? 'Refreshing…' : 'Refresh'}
            </button>
          </div>
        </div>

        {/* ── Stat Cards ── */}
        <div style={{ padding: '20px 32px 0', display: 'grid', gridTemplateColumns: '1fr 1.1fr 1fr 1fr', gap: 16, flexShrink: 0 }}>

          {/* Total */}
          <div style={{ background: '#fff', borderRadius: 16, padding: '22px 24px', border: '1px solid #e8edf2', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: '0.07em', textTransform: 'uppercase', marginBottom: 8 }}>TOTAL DEVICES</div>
            <div style={{ fontSize: 42, fontWeight: 800, color: '#0f172a', lineHeight: 1, marginBottom: 10 }}>{stats.total}</div>
            <span style={{ fontSize: 11, fontWeight: 600, color: '#10b981', background: '#d1fae5', padding: '2px 8px', borderRadius: 20 }}>
              ↑ +12.5% vs last month
            </span>
          </div>

          {/* Active Now */}
          <div style={{
            background: 'linear-gradient(135deg,#0D47A1 0%, #0D47A1 100%)',
            borderRadius: 16, padding: '22px 24px',
            boxShadow: '0 4px 20px rgba(15,23,42,0.25)',
            display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
          }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', letterSpacing: '0.07em', textTransform: 'uppercase' }}>ACTIVE NOW</div>
            <div style={{ fontSize: 48, fontWeight: 800, color: '#fff', lineHeight: 1, margin: '8px 0 10px' }}>{stats.active}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#22d3ee', display: 'inline-block', boxShadow: '0 0 8px #22d3ee' }}/>
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', fontWeight: 500 }}>Live Session Monitoring</span>
            </div>
          </div>

          {/* Desktop */}
          <div style={{ background: '#fff', borderRadius: 16, padding: '22px 24px', border: '1px solid #e8edf2', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: '0.07em', textTransform: 'uppercase' }}>DESKTOP</div>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#64748b', background: '#f1f5f9', padding: '2px 8px', borderRadius: 12 }}>{desktopPct}%</span>
            </div>
            <div style={{ color: '#94a3b8', marginBottom: 8 }}><Ic.Monitor /></div>
            <div style={{ fontSize: 36, fontWeight: 800, color: '#0f172a', lineHeight: 1 }}>{stats.desktop}</div>
          </div>

          {/* Mobile */}
          <div style={{ background: '#fff', borderRadius: 16, padding: '22px 24px', border: '1px solid #e8edf2', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: '0.07em', textTransform: 'uppercase' }}>MOBILE</div>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#64748b', background: '#f1f5f9', padding: '2px 8px', borderRadius: 12 }}>{mobilePct}%</span>
            </div>
            <div style={{ color: '#94a3b8', marginBottom: 8 }}><Ic.Phone /></div>
            <div style={{ fontSize: 36, fontWeight: 800, color: '#0f172a', lineHeight: 1 }}>{stats.mobile}</div>
          </div>
        </div>

        {/* ── Table Section ── */}
        <div style={{ margin: '20px 32px 24px', flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>

          {/* ── Tabs Row + Filter + Export (all in one row) ── */}
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            background: '#fff', borderRadius: '14px 14px 0 0',
            padding: '14px 20px',
            border: '1px solid #e8edf2', borderBottom: '1px solid #f1f5f9',
            flexShrink: 0,
            gap: 12,
          }}>
            {/* Left: Tabs */}
            <div style={{ display: 'flex', gap: 4, background: '#f8fafc', borderRadius: 10, padding: 4, flexShrink: 0 }}>
              {[
                { key: 'all',      label: 'All Devices' },
                { key: 'active',   label: 'Active' },
                { key: 'inactive', label: 'Inactive' },
                { key: 'users',    label: 'Users' },
              ].map(t => (
                <TabBtn key={t.key} active={activeTab === t.key} onClick={() => { setActiveTab(t.key); setPage(1); }}>
                  {t.label}
                </TabBtn>
              ))}
            </div>

            {/* Right: Filter dropdown trigger + Export button */}
            {activeTab !== 'users' && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0, position: 'relative' }}>

                {/* Active filter tags (inline, compact) */}
                {activeTagKeys.length > 0 && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                    {activeTagKeys.map(key => (
                      <span key={key} style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        padding: '2px 8px 2px 9px', background: '#eff6ff',
                        border: '1px solid #bfdbfe', borderRadius: 20,
                        fontSize: 11, fontWeight: 600, color: '#1e40af',
                      }}>
                        {tagLabels[key](appliedFilters[key])}
                        <button
                          onClick={() => removeTag(key)}
                          style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            width: 14, height: 14, border: 'none', background: '#bfdbfe',
                            borderRadius: '50%', cursor: 'pointer', padding: 0, color: '#1e40af',
                          }}
                        >
                          <Ic.X />
                        </button>
                      </span>
                    ))}
                  </div>
                )}

                {/* Filter Button */}
                <button
                  onClick={() => setFilterOpen(v => !v)}
                  className={activeTagKeys.length > 0 ? 'udm-filter-btn-active' : ''}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 6,
                    padding: '7px 14px', height: 34,
                    background: activeTagKeys.length > 0 ? '#eff6ff' : '#f8fafc',
                    border: `1px solid ${activeTagKeys.length > 0 ? '#3b82f6' : '#e2e8f0'}`,
                    borderRadius: 8, fontSize: 13, fontWeight: 500,
                    cursor: 'pointer', fontFamily: 'inherit',
                    color: activeTagKeys.length > 0 ? '#1d4ed8' : '#374151',
                    transition: 'all .15s',
                  }}
                >
                  <Ic.Filter />
                  Filters
                  {activeTagKeys.length > 0 && (
                    <span style={{
                      background: '#3b82f6', color: '#fff',
                      borderRadius: '50%', width: 16, height: 16,
                      fontSize: 10, fontWeight: 700,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                      {activeTagKeys.length}
                    </span>
                  )}
                  <Ic.ChevronDown />
                </button>

                {/* Export Button */}
                <button
                  onClick={exportToExcel}
                  className="udm-export-btn"
                  style={{
                    display: 'flex', alignItems: 'center', gap: 6,
                    padding: '7px 16px', height: 34,
                    background: '#0D47A1', color: '#fff',
                    border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600,
                    cursor: 'pointer', fontFamily: 'inherit',
                    transition: 'background .15s',
                    boxShadow: '0 2px 6px rgba(13,71,161,0.25)',
                  }}
                >
                  <Ic.Excel />
                  Export to Excel
                </button>

                {/* Filter Dropdown */}
                {filterOpen && (
                  <>
                    {/* Backdrop */}
                    <div
                      onClick={() => setFilterOpen(false)}
                      style={{ position: 'fixed', inset: 0, zIndex: 99 }}
                    />
                    <div className="udm-filter-dropdown">
                      <div style={{ fontSize: 12, fontWeight: 700, color: '#64748b', marginBottom: 14, letterSpacing: '.05em', textTransform: 'uppercase' }}>
                        Filter Devices
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>

                        {/* User Name */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <span style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', letterSpacing: '.07em', textTransform: 'uppercase' }}>User Name</span>
                          <input
                            className="udm-fi"
                            value={filters.user}
                            onChange={e => setFilter('user', e.target.value)}
                            onKeyDown={e => e.key === 'Enter' && applyFilters()}
                            placeholder="Search user…"
                            style={{ ...inputStyle, width: '100%' }}
                          />
                        </div>

                        {/* Device Type */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <span style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', letterSpacing: '.07em', textTransform: 'uppercase' }}>Device Type</span>
                          <select
                            className="udm-fi"
                            value={filters.deviceType}
                            onChange={e => setFilter('deviceType', e.target.value)}
                            style={{ ...inputStyle, width: '100%', cursor: 'pointer' }}
                          >
                            <option value="">All Types</option>
                            <option value="desktop">Desktop</option>
                            <option value="mobile">Mobile</option>
                            <option value="tablet">Tablet</option>
                          </select>
                        </div>

                        {/* From */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <span style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', letterSpacing: '.07em', textTransform: 'uppercase' }}>Activity From</span>
                          <input
                            className="udm-fi"
                            type="date"
                            value={filters.from}
                            onChange={e => setFilter('from', e.target.value)}
                            style={{ ...inputStyle, width: '100%' }}
                          />
                        </div>

                        {/* To */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          <span style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', letterSpacing: '.07em', textTransform: 'uppercase' }}>Activity To</span>
                          <input
                            className="udm-fi"
                            type="date"
                            value={filters.to}
                            onChange={e => setFilter('to', e.target.value)}
                            style={{ ...inputStyle, width: '100%' }}
                          />
                        </div>
                      </div>

                      {/* Dropdown Actions */}
                      <div style={{ display: 'flex', gap: 8, marginTop: 14, justifyContent: 'flex-end' }}>
                        <button
                          onClick={resetFilters}
                          style={{
                            padding: '7px 14px', background: '#f1f5f9', color: '#64748b',
                            border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 13,
                            fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', height: 34,
                          }}
                        >
                          Reset
                        </button>
                        <button
                          onClick={applyFilters}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 6,
                            padding: '7px 16px', background: '#0D47A1', color: '#fff',
                            border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600,
                            cursor: 'pointer', fontFamily: 'inherit', height: 34,
                          }}
                        >
                          <Ic.Filter /> Apply Filters
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

          {/* ── Table ── */}
          <div className="udm-scroll" style={{
            flex: 1, overflowY: 'auto', overflowX: 'auto',
            background: '#fff',
            border: '1px solid #e8edf2', borderTop: 'none',
            borderRadius: filtered.length > 0 ? '0' : '0 0 14px 14px',
          }}>
            {activeTab === 'users' ? (
              <div style={{ padding: '20px' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                  {usersAuth.map(user => (
                    <div key={user._id} style={{
                      display: 'flex', alignItems: 'center', gap: 12,
                      padding: '12px 16px', background: '#f8fafc',
                      border: '1px solid #e8edf2', borderRadius: 12,
                    }}>
                      <Avatar src={user.profileImg} name={user.name} size={40} />
                      <div>
                        <div style={{ fontSize: 14, fontWeight: 600, color: '#0f172a' }}>{user.name}</div>
                        <div style={{ fontSize: 12, color: '#94a3b8' }}>{user.role || 'User'}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : loading ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 220, gap: 12, color: '#94a3b8' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="udm-spin">
                  <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
                </svg>
                Loading devices…
              </div>
            ) : pageItems.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '60px 24px' }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>🔍</div>
                <div style={{ fontSize: 15, fontWeight: 600, color: '#334155', marginBottom: 6 }}>No devices found</div>
                <div style={{ fontSize: 13, color: '#94a3b8' }}>
                  {activeTagKeys.length > 0 ? 'Try adjusting or resetting your filters.' : 'No devices available.'}
                </div>
                {activeTagKeys.length > 0 && (
                  <button
                    onClick={resetFilters}
                    style={{
                      marginTop: 16, padding: '8px 18px', background: '#0D47A1', color: '#fff',
                      border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600,
                      cursor: 'pointer', fontFamily: 'inherit',
                    }}
                  >
                    Reset Filters
                  </button>
                )}
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    {['DEVICE TYPE', 'AUTHORIZED USER', 'IP & LOCATION', 'PLATFORM', 'STATUS', 'ACTIVITY'].map(h => (
                      <th key={h} style={{
                        padding: '11px 20px', textAlign: 'left',
                        fontSize: 11, fontWeight: 700, color: '#94a3b8',
                        letterSpacing: '0.07em', textTransform: 'uppercase',
                        borderBottom: '1px solid #f1f5f9', whiteSpace: 'nowrap',
                      }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {pageItems.map((device, i) => {
                    const di     = getDeviceInfo(device.deviceType, device.deviceName);
                    const br     = getBrowser(device.userAgent);
                    const isLast = i === pageItems.length - 1;
                    const statusKey = device.isActive ? 'active' : 'inactive';

                    return (
                      <tr
                        key={device._id}
                        className="udm-row"
                        style={{ borderBottom: isLast ? 'none' : '1px solid #f8fafc', background: 'transparent' }}
                      >
                        {/* Device Type */}
                        <td style={{ padding: '14px 20px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{
                              width: 38, height: 38, borderRadius: 10,
                              background: di.bg, color: di.color,
                              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                            }}>
                              <di.Icon />
                            </div>
                            <div>
                              <div style={{ fontWeight: 600, color: '#0f172a', fontSize: 13 }}>{di.label}</div>
                              <div style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', letterSpacing: '0.06em', marginTop: 1 }}>{di.sub}</div>
                            </div>
                          </div>
                        </td>

                        {/* Authorized User */}
                        <td style={{ padding: '14px 20px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <Avatar src={device.userId?.profileImg} name={device.userId?.name || '?'} size={34} />
                            <div>
                              <div style={{ fontWeight: 600, color: '#0f172a', fontSize: 13 }}>{device.userId?.name || 'Unknown'}</div>
                              <div style={{ fontSize: 12, color: '#94a3b8' }}>{device.userId?.role || '—'}</div>
                            </div>
                          </div>
                        </td>

                        {/* IP & Location */}
                        <td style={{ padding: '14px 20px' }}>
                          <div style={{ fontWeight: 600, color: '#334155', fontSize: 13, fontFamily: 'monospace', letterSpacing: '0.02em' }}>
                            {device.ipAddress || '—'}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 3, color: '#94a3b8', fontSize: 12 }}>
                            <Ic.Pin />
                            {[device?.location?.city, device?.location?.country].filter(Boolean).join(', ') || 'Unknown'}
                          </div>
                        </td>

                        {/* Platform / Browser */}
                        <td style={{ padding: '14px 20px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{
                              width: 26, height: 26, borderRadius: 6,
                              background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center',
                              fontSize: 14,
                            }}>
                              {br.logo}
                            </div>
                            <div style={{ fontWeight: 600, color: '#334155', fontSize: 13 }}>{br.name} {br.version}</div>
                          </div>
                        </td>

                        {/* Status */}
                        <td style={{ padding: '14px 20px' }}>
                          <StatusBadge status={statusKey} />
                        </td>

                        {/* Activity */}
                        <td style={{ padding: '14px 20px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontWeight: 500, color: '#334155', fontSize: 13 }}>
                            <span style={{ color: '#cbd5e1' }}><Ic.Clock /></span>
                            {getTimeAgo(device.lastActivity)}
                          </div>
                          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                            {new Date(device.lastActivity).toLocaleDateString()}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>

          {/* ── Pagination ── */}
          {filtered.length > 0 && activeTab !== 'users' && (
            <div style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '14px 20px', background: '#fff',
              border: '1px solid #e8edf2', borderTop: '1px solid #f1f5f9',
              borderRadius: '0 0 14px 14px', flexShrink: 0,
            }}>
              <span style={{ fontSize: 13, color: '#64748b' }}>
                Showing <strong style={{ color: '#0f172a' }}>{Math.min(pageItems.length, filtered.length)}</strong> of{' '}
                <strong style={{ color: '#0f172a' }}>{filtered.length}</strong> connected devices
              </span>
              <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                <button
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                  disabled={page === 1}
                  style={{
                    width: 30, height: 30, borderRadius: 8, border: '1px solid #e2e8f0',
                    background: '#fff', cursor: page === 1 ? 'not-allowed' : 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#64748b', opacity: page === 1 ? 0.4 : 1,
                  }}
                ><Ic.ChevronLeft /></button>

                {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => i + 1).map(n => (
                  <button
                    key={n}
                    onClick={() => setPage(n)}
                    style={{
                      width: 30, height: 30, borderRadius: 8,
                      border: page === n ? 'none' : '1px solid #e2e8f0',
                      background: page === n ? '#0D47A1' : '#fff',
                      color: page === n ? '#fff' : '#374151',
                      fontSize: 13, fontWeight: page === n ? 700 : 500,
                      cursor: 'pointer', fontFamily: 'inherit',
                    }}
                  >{n}</button>
                ))}

                <button
                  onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages || totalPages === 0}
                  style={{
                    width: 30, height: 30, borderRadius: 8, border: '1px solid #e2e8f0',
                    background: '#fff',
                    cursor: (page === totalPages || totalPages === 0) ? 'not-allowed' : 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#64748b', opacity: (page === totalPages || totalPages === 0) ? 0.4 : 1,
                  }}
                ><Ic.ChevronRight /></button>
              </div>
            </div>
          )}
        </div>

        {/* ── Footer ── */}
        <footer style={{ padding: '16px 32px', flexShrink: 0, borderTop: '1px solid #e8edf2' }}>
          <span style={{ fontSize: 12, color: '#94a3b8' }}>© 2026 Realatix CRM — Device Management</span>
        </footer>
      </div>
    </div>
  );
};